import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <main className="min-h-[70vh] bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <div className="rounded-2xl bg-white border border-neutral-200 p-8 md:p-10 shadow-sm">
          <XCircle className="mx-auto text-neutral-400" size={48} />
          <h1 className="mt-4 text-2xl md:text-3xl font-extrabold text-neutral-900">
            Checkout cancelled
          </h1>
          <p className="mt-2 text-neutral-600">
            No worries — no charge was made. Your plan is still waiting for you.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/plans">
              <Button className="rounded-full bg-green-600 hover:bg-green-700 text-white px-6">
                Back to Plans
              </Button>
            </Link>
            <Link to="/menu">
              <Button variant="outline" className="rounded-full border-neutral-300 px-6">See menu</Button>
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
